/**
 * TerminateTestSessionsButton
 *
 * A button component for stopping all running test sessions for a project.
 * Displays a loading indicator while termination is in progress
 * and triggers a refresh once complete.
 */
import React, { useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import { Stop } from '@mui/icons-material';
import { send_request } from '../../../utils/Request';

const TerminateTestSessionsButton = ({ projectId, version, onSuccess }) => {
  const [isTerminatingTestSessions, setIsTerminatingTestSessions] = useState(false);

  const terminateTestSessions = async () => {
    if (!projectId || !version) {
      console.error('Cannot terminate sessions: Missing projectId or version');
      return;
    }

    setIsTerminatingTestSessions(true);

    try {
      const url = `project-service/project-session/terminate_test_sessions/${projectId}/${version}`;
      const response = await send_request(url, {}, null, 'POST');

      if (response) {
        if (onSuccess) {
          onSuccess();
        }
      }
    } catch (error) {
      console.error('Failed to terminate test sessions:', error);
    } finally {
      setIsTerminatingTestSessions(false);
    }
  };

  const buttonStyles = {
    textTransform: 'unset !important',
    color: 'error.main',
    marginRight: '8px',
    borderColor: 'error.main',
    '&:hover': {
      borderColor: 'error.dark',
      backgroundColor: 'rgba(244, 67, 54, 0.04)',
    },
  };

  return (
    <Button
      sx={buttonStyles}
      variant="outlined"
      size="small"
      startIcon={
        isTerminatingTestSessions ? <CircularProgress size={16} color="error" /> : <Stop />
      }
      onClick={terminateTestSessions}
      disabled={isTerminatingTestSessions}
    >
      {isTerminatingTestSessions ? 'Terminating...' : 'Stop test runs'}
    </Button>
  );
};

export default TerminateTestSessionsButton;
